var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.52 16.51a13.79 13.79 0 0 0-.218-2.455H16v4.642h6.458a5.52 5.52 0 0 1-2.395 3.622v3.011h3.878c2.269-2.089 3.578-5.166 3.578-8.82z",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.238c3.24 0 5.956-1.075 7.942-2.907l-3.878-3.011c-1.074.72-2.449 1.145-4.064 1.145-3.125 0-5.771-2.111-6.715-4.947H5.276v3.109C7.25 25.549 11.309 28.238 16 28.238z",
    fill: "#34a853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.285 18.517c-.24-.72-.376-1.489-.376-2.28s.136-1.56.376-2.28v-3.109H5.276C4.464 12.468 4 14.301 4 16.237s.464 3.769 1.276 5.389l4.009-3.109z",
    fill: "#fbbc05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.01c1.762 0 3.344.605 4.587 1.795l3.442-3.442C21.951 5.426 19.234 4.237 16 4.237c-4.691 0-8.749 2.689-10.724 6.611l4.009 3.109C10.229 11.121 12.874 9.01 16 9.01z",
    fill: "#ea4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e6ad40b935df2e9b3d4e5abd4135ef0f3327922b007a5889510bae30e7e1641d.svg";
export { ForwardRef as ReactComponent };